import React, { createContext, useContext, useState } from 'react';
import { useAuth } from './AuthContext';
import { GetDataCoursesServices } from '../services/getDataCourses/GetDataCoursesServices';
import logsUserService from '../services/LogsUserActionService';

const CourseContentContext = createContext();

export const useCourseContent = () => useContext(CourseContentContext);

export const CourseContentProvider = ({ children }) => {
  const { token, idUser } = useAuth();
  const [stars, setStars] = useState(0);
  const [isFavorite, setIsFavorite] = useState(false);
  const [dataCourse, setDataCourse] = useState(null);
  const [dataTasks, setDataTasks] = useState([]);
  const [idCourse, setIdCourse] = useState(null);

  const getDataCourse = async (id) => {
    setIdCourse(id);
    const responseDataCourse = await GetDataCoursesServices(token, id);
    if (responseDataCourse.errors) {
      setDataCourse(null);
      setDataTasks([]);
    } else {
      setDataCourse(responseDataCourse?.data?.course);
      setDataTasks(responseDataCourse?.data?.tasks);
    }
  };

  const sendLog = async (course, task, fav = null, stars = null, type = null) => {
    let action = '';

    // Acciones especiales por tipo
    if (type === 'play') {
      action = `Tarea: ${task} | Clic en reproducir video`;
    } else if (type === 'view-tasks') {
      action = `Vista de tareas del curso: ${course}`;
    } else if (type === 'view-favorites') {
      action = `Vista de favoritas del curso: ${course}`;
    } else if (stars != null) {
      action = `Tarea: ${task} | Calificada con ${stars} estrellas`;
    } else if (fav != null) {
      action = fav
        ? `Tarea: ${task} | Tarea marcada como favorita`
        : `Tarea: ${task} | Tarea desmarcada como favorita`;
    } else if (task) {
      action = `Clic en la tarea: ${task}, dentro del curso: ${course}`;
    } else {
      action = `Clic en el curso: ${course}`;
    }

    try {
      await logsUserService(idUser, action, token);
    } catch (error) {
      console.error('Error logging user action:', error);
    }
  };

  return (
    <CourseContentContext.Provider
      value={{
        stars,
        setStars,
        isFavorite,
        setIsFavorite,
        dataCourse,
        setDataCourse,
        getDataCourse,
        dataTasks,
        setDataTasks,
        idCourse,
        setIdCourse,
        sendLog
      }}
    >
      {children}
    </CourseContentContext.Provider>
  );
};
